
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {},
data () {
return {
user: {
userId: ''
},
prevImages: [],
previewOptions: {},
info: {
id: '',
title: '',
author: '',
time: '',
img: '',
imgList: [],
fcontent: '',
scontent: '',
url: ''
}
}
},
beforeRouteEnter (to, from, next) {
next(vm => {
vm.user = vm.$store.state.sx.user || vm.user
vm.$post('article/detail', {
id: to.params.id,
type: '700',
userId: vm.user.userId
}, (res) => {
if (res.code === 200) {
for (let item in res.data) {
if (res.data[item] !== undefined && res.data[item] !== null) {
vm.info[item] = res.data[item]
}
}
for (let img in vm.info.imgList) {
vm.prevImages.push({
msrc: vm.info.imgList[img],
src: vm.info.imgList[img]
})
}
if (!vm.info.img && vm.info.imgList.length === 1) {
vm.info.img = vm.info.imgList[0]
}
if (vm.$isWechat()) {
let shareLink = window.location.href
let shareDesc = ''
let shareImage = vm.info.img
if (!shareImage && vm.info.imgList && vm.info.imgList.length) {
shareImage = vm.info.imgList[0]
}
vm.$wechatShare(null, shareLink, to.meta.title, shareDesc, shareImage)
}
}
})
})
},
methods: {
preview (index) {
this.$refs.prevImage.show(index)
}
}
}



// WEBPACK FOOTER //
// ./src/page/ProductView.vue